import { Component, ElementRef, Input, ViewChild } from '@angular/core'
import * as d3 from 'd3'
import $ from 'jquery'

const object = {}
const strokeColor = 'rgb(255, 255, 255)'
const strokeWidth = 'stroke-width'

@Component({
  selector: 'exemplar-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss'],
})
export class DonutChartComponent {
  private _chartData: any
  private _selectPathData: { chartId: string; tableId: string; trId: string }
  @Input() chartId: any
  @Input() tableId: any
  @Input() decimals: any
  @Input()
  set chartData(value: any) {
    this._chartData = value
    if (this._chartData && this._chartData.length > 0) {
      object[this.chartId] = this
      object[this.chartId].clicked = 'empty'
      this.createDonutChart(this._chartData, this.chartId, this.tableId)
    }
  }
  @Input()
  set selectPathData(value: {
    chartId: string
    tableId: string
    trId: string
  }) {
    this._selectPathData = value
    if (value) {
      this.selectPathOfDonutChart(value.tableId, value.chartId, value.trId)
    }
  }

  @ViewChild('containerDonutChart', { static: true })
  containerPieChart: ElementRef
  private readonly host: d3.Selection<any, any, any, any>
  private readonly svg: d3.Selection<any, any, any, any>
  htmlElement: any
  previousIndex: any = 0
  arcOver
  color
  arc

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  width = 350
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  height = 350
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  thickness = 10 /*size of path*/
  radius =
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    Math.min(this.width, this.height) /
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    2.5
  constructor() {
    //
  }
  // eslint-disable-next-line complexity, max-statements
  createDonutChart(data, chartId, tableId) {
    this.htmlElement = this.containerPieChart.nativeElement
    const host = d3.select(this.htmlElement)
    host.html('')
    const idArray = [],
      colorCodeArray = []
    let path,
      hasValues = false
    const svg = host
        .append('svg')
        .attr('class', 'pie')
        .attr('width', this.width)
        .attr('height', this.height)
        .attr('id', chartId + 'svg'),
      g = svg
        .append('g')
        .attr(
          'transform',
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          `translate(${this.width / 2}, ${this.height / 2})`,
        )
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        .attr('stroke', strokeColor)
        .attr(strokeWidth, '0'),
      pie = d3
        .pie()
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        .value((d: any) => {
          return d.value
        })
        .sort(null)
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        .padAngle(0.005) /*to add gap in two sections*/
    this.drawArc()
    data.forEach((item) => {
      idArray.push(item.id)
      colorCodeArray.push(item.color)
      if (
        !isNaN(parseInt(item.value, 10)) &&
        (item.value > 0 || item.value < 0)
      ) {
        hasValues = true
      }
    })
    if (hasValues) {
      this.color = d3.scaleOrdinal().domain(idArray).range(colorCodeArray)
      path = g
        .selectAll('path')
        .data(pie(data))
        .enter()
        .append('g')
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .attr('class', function (d, i) {
          return chartId + i
        })
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .attr('id', function (d: any, i) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          return d.data.id
        })
        .append('path')
        .attr('d', this.arc)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .attr('fill', (d, i) => {
          return this.color(i)
        })
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .on('mouseover', function (d, i) {
          //   obj.selectPathOfDonutChart(tableId, chartId, d.data.id)
        })
      this.chartDataPathSelection(path, data, tableId, chartId)
    } else {
      this.fillTableSvg(data, tableId)
    }
    return object[this.chartId].clicked
  }

  chartDataPathSelection(
    path: any,
    data: any,
    tableId: string,
    chartId: string,
  ) {
    path.select('g')
    this.fillTableSvg(data, tableId)
    //Calling for highlighted 1st record/path
    setTimeout(() => {
      this.selectPathOfDonutChart(
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        tableId,
        chartId,
        data[0].id,
      )
      this._chartData.forEach((item) => {
        document.getElementById(item.id)?.addEventListener(
          'mouseover',
          function () {
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            object[chartId].selectPathOfDonutChart(tableId, chartId, item.id)
          },
          false,
        )
      })
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    }, 500) //waiting to get  arc created.
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  selectPathOfDonutChart(tableId, chartId, trIndex) {
    const g = d3
      .select('#' + chartId)
      .select('svg')
      .select('g')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this._chartData.forEach(function (item, key) {
      if (document.getElementById(item.id + 'TR') !== null) {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        document.getElementById(item.id + 'TR').classList.remove('trBG')
      }
    })
    const arc = d3
      .arc()
      .innerRadius(this.radius - this.thickness)
      .outerRadius(this.radius)
    const arcOver = d3
      .arc() /*20 is outer width on hover*/
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      .innerRadius(this.radius + 20)
      .outerRadius(this.radius - this.thickness)
    function wrap(text, width) {
      text.each(function () {
        text = d3.select(this)
        let word = '',
          line = []
        const words = text.text().split(/\s+/).reverse(),
          y = text.attr('y'),
          dy = parseFloat(text.attr('dy'))
        let tspan = text
          .text(null)
          .append('tspan')
          .attr('x', 0)
          .attr('y', y)
          .attr('dy', dy + 'em')
        word = words.pop()
        while (word) {
          line.push(word)
          tspan.text(line.join(' '))
          if (tspan.node().getComputedTextLength() > width) {
            line.pop()
            tspan.text(line.join(' '))
            line = [word]
            tspan = text
              .append('tspan')
              .attr('x', 0)
              .attr('y', y)
              .attr('dy', '1.1em')
              .text(word)
          }
          word = words.pop()
        }
      })
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    g.selectAll('path').each(function (d: any, i) {
      if (d.data.id === trIndex && !isNaN(parseInt(d.data.value, 10))) {
        $('.text-group .name-text').remove()
        $('.text-group .value-text').remove()
        g.selectAll('text').remove()
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        g.selectAll('g')
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          .selectAll('g')
          .remove()
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        g.append('text')
          .attr('class', 'value-text')
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          .text((+d.data.value).toFixed(object[chartId].decimals) + '%')
          .attr('text-anchor', 'middle')
          .attr('dy', '0.1em')

        g.append('text')
          .attr('class', 'name-text')
          .text(d.data.name)
          .attr('text-anchor', 'middle')
          .attr('dy', '2em')
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          .call(wrap, 210)
        document.getElementById(d.data.id + 'TR').classList.add('trBG')
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        d3.select(this).style('cursor', 'pointer')
        /* .style("fill", "gray");*/
        d3.select(this)
          .transition()
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          .duration(200)
          /*Change arc on mouse over arcOver var. Adjust as per change width height and radius*/
          .attr('d', arcOver)
          /*Add border to arch using stroke*/
          .attr('stroke', strokeColor)
          .attr(strokeWidth, '0')
        document.getElementById(d.data.id + 'TR').classList.add('trBG')
        if (
          object[chartId].clicked !== 'empty' &&
          object[chartId].clicked !== this
        ) {
          d3.select(object[chartId].clicked)
            .transition()
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            .duration(200)
            /*Add or remove border to arch using stroke. For remove add background color as stroke*/
            .attr('d', arc)
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            .attr('stroke', strokeColor)
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            .attr(strokeWidth, '0.05')
        }
        object[chartId].clicked = this
      }
    })
    return object[chartId].clicked
  }
  fillTableSvg(data, tableId) {
    setTimeout(() => {
      data.forEach((value, key) => {
        $(`#${tableId} #cr${key}`).attr('style', 'fill :' + value.color)
      })
      $(`#${data[0].id}TR`).addClass('trBG')
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    }, 200)
  }
  drawArc() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.arc = d3
      .arc()
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      .innerRadius(this.radius - this.thickness)
      .outerRadius(this.radius)
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.arcOver = d3
      .arc() /*20 is outer width on hover*/
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      .innerRadius(this.radius + 20)
      .outerRadius(this.radius - this.thickness)
  }
}
